export default __webpack_public_path__ + "static/media/logo.b6b44c03.png";